import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { httpClient } from '../api/httpClient';

interface CacheProvider {
  name: string;
  type: string;
  priority: number;
}

interface CacheStore {
  selectedProvider: string | null;
  providers: CacheProvider[];
  currentProviderName: string | null; // The one actually in use by backend
  isLoading: boolean;
  
  fetchProviders: () => Promise<void>;
  setSelectedProvider: (name: string | null) => void;
}

export const useCacheStore = create<CacheStore>()(
  persist(
    (set) => ({
      selectedProvider: null,
      providers: [],
      currentProviderName: null,
      isLoading: false,

      fetchProviders: async () => {
        set({ isLoading: true });
        try {
          const response = await httpClient.get<{
            providers: CacheProvider[];
            current: string;
            requested: string | null;
          }>('/api/cache/providers');
          
          if (response.success && response.data) {
            set({ 
              providers: response.data.providers,
              currentProviderName: response.data.current
            });
            
            // If we have a selected provider but it's not in the list, clear it?
            // Or if we don't have a selected provider, maybe set it to current?
            // For now, let's keep selectedProvider as user preference.
          }
        } catch (error) {
          console.error('Failed to fetch cache providers:', error);
        } finally {
          set({ isLoading: false });
        }
      },

      setSelectedProvider: (name) => {
        set({ selectedProvider: name });
      },
    }),
    {
      name: 'cache-storage',
      partialize: (state) => ({ selectedProvider: state.selectedProvider }),
    }
  )
);
